import { AppSpan, AppText, Button, CustomContainer, FlexRow, GridContainer } from "src/style"
import { AppCenterPopupD3, CenterPopupHeaderD3 } from "src/component"

export const SavingsDetailsD3: React.FC<any> = ({data, handleLiquidate, handleAddFund, close}) => {

    return (
        <AppCenterPopupD3 height='58' zIndex='6' overflow='hidden' close={close}>
            <CenterPopupHeaderD3 title='Savings Details' close={close} />
            <CustomContainer 
                height='58'
                style={{maxHeight: '88%'}}
                className="popup-content-container"
            >
                <CustomContainer
                    minHeight="19.6" borderColor="#EAECF0" padding="2" radius="0.8"
                >
                    <FlexRow justifyContent="space-between" gap="1.5" topMargin="1.5" wrap="wrap">
                        <GridContainer width="auto" sizeUnit="" alignItems="start">
                            <AppSpan>Debit Amount</AppSpan>
                            <AppText fontWeight="700" color="#0D968F">N20,000</AppText>
                        </GridContainer>
                        <GridContainer width="auto" sizeUnit="" alignItems="end">
                            <AppSpan>Target Amount</AppSpan>
                            <AppText fontWeight="700" color="#0D968F">N100,000</AppText>
                        </GridContainer>
                    </FlexRow>
                    <FlexRow justifyContent="space-between" gap="1.5" topMargin="1.5" wrap="wrap">
                        <GridContainer width="auto" sizeUnit="" alignItems="start">
                            <AppSpan>Percentage Saved</AppSpan>
                            <AppText fontWeight="700" color="#0D968F">20</AppText>
                        </GridContainer>
                        <GridContainer width="auto" sizeUnit="" alignItems="end">
                            <AppSpan>Frequency of Savings</AppSpan>
                            <AppText fontWeight="700" color="#0D968F">Monthly</AppText>
                        </GridContainer>
                    </FlexRow>
                    <FlexRow justifyContent="space-between" gap="1.5" topMargin="1.5" wrap="wrap">
                        <GridContainer width="auto" sizeUnit="" alignItems="start">
                            <AppSpan>Target Date</AppSpan>
                            <AppText fontWeight="700" color="#0D968F">04/01/2023</AppText>
                        </GridContainer>
                        <GridContainer width="auto" sizeUnit="" alignItems="end">
                            <AppSpan>Next payment Date</AppSpan>
                            <AppText fontWeight="700" color="#0D968F">12/08/2025</AppText>
                        </GridContainer>
                    </FlexRow>
                    <FlexRow justifyContent="space-between" gap="1.5" topMargin="1.5" wrap="wrap">
                        <GridContainer width="auto" sizeUnit="" alignItems="start">
                            <AppSpan>Interest Rate</AppSpan>
                            <AppText fontWeight="700" color="#0D968F">12%</AppText>
                        </GridContainer>
                        <GridContainer width="auto" sizeUnit="" alignItems="end">
                            <AppSpan>Accrued Interest</AppSpan>
                            <AppText fontWeight="700" color="#0D968F">N2,345</AppText>
                        </GridContainer>
                    </FlexRow>
                    <GridContainer
                        bgColor="rgba(13, 150, 143, 0.07)"
                        radius="0.5" height="2.6" topMargin="1.5"
                    >
                        <FlexRow justifyContent="space-between" rightPadding="1">
                            <GridContainer 
                                height="2.6" bgColor="#0D968F" radius="0.5" 
                                width="auto" sizeUnit="" leftPadding="1" rightPadding="1"
                            >
                                <AppText textSize="0.9" fontWeight="500" color="#ffffff">N 20,000</AppText>
                            </GridContainer>
                            <AppText textSize="0.9" fontWeight="600" color="#0D968F">N 200,000</AppText>
                        </FlexRow>
                    </GridContainer>
                    <AppText 
                        align="center" textSize="0.9" color="#0D968F" 
                        fontWeight="600" topMargin="1" width="100" sizeUnit="%"
                    >
                        Percentage Saved: 20%
                    </AppText>
                </CustomContainer>
                <CustomContainer topMargin="2.5">
                        <Button 
                            width='100' sizeUnit="%" height='4' 
                            borderColor='#0D968F' hoverBgColor='#ffffff' 
                            hoverColor='#0D968F' titleSize='1.4'
                            onClick={handleAddFund}
                        >
                            Add Funds
                        </Button>
                        <Button 
                            width='100' sizeUnit="%" height='4' 
                            bgColor="#ffffff" topMargin="1.5"
                            borderColor='#D0D5DD' hoverBgColor='#ffffff' 
                            hoverColor='#0D968F' titleSize='1.4' color="#344054"
                            onClick={handleLiquidate}
                        >
                            Liquidate Funds
                        </Button>
                    </CustomContainer>
            </CustomContainer>
        </AppCenterPopupD3>
    )
}